var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card', _vm._b({
    staticClass: "purchase-method-item",
    on: {
      "click": function click($event) {
        return _vm.emit(_vm.item.value);
      }
    }
  }, 'v-card', _vm.props_card, false), [_c('v-row', {
    attrs: {
      "no-gutters": "",
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-card-title', {
    staticClass: "purchase-method-item__name"
  }, [_c('v-icon', [_vm._v(_vm._s(_vm.icon))]), _vm._v(" " + _vm._s(_vm.item.text) + " ")], 1)], 1), _c('v-spacer'), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "auto"
    }
  }, [_c('v-card-text', {
    staticClass: "purchase-method-item__text"
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.item.desc)
    }
  })])], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }